<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="套餐名称" class="fn-left">
            <el-input v-model="listQuery.item_title" />
          </el-form-item>
          <el-form-item label="套餐状态" class="fn-left">
            <Select key="5" :selected.sync="listQuery.is_delete" :data="packageStatus" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="套餐类型" class="fn-left">
            <Select key="9" :selected.sync="listQuery.item_type" :data="packageTypes" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="12" :selected.sync="listQuery.subject_id" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetShopItemList">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddPakcage()">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="item_id" align="center" />
        <el-table-column label="套餐名称" prop="name" align="center" />
        <el-table-column label="套餐类型" prop="type_name" align="center" />
        <el-table-column label="适用科目" prop="subject_name" align="center" />
        <el-table-column label="有效天数" prop="effective_day" align="center" />
        <el-table-column label="套餐金额" align="center">
          <template slot-scope="{row}">
            <p>{{ row.total_price/100 }}</p>
          </template>
        </el-table-column>
        <el-table-column label="适用年级" prop="grade_name" align="center" />
        <el-table-column label="套餐状态" align="center">
          <template slot-scope="{row}">
            <p>{{ row.is_delete == 1 ? "关闭" : "开启" }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="fnGetExerciseDetail(row.exercise_id)">查看</el-button> -->
            <el-button v-if="row.is_delete == 0" type="text" :loading="currentLoading == row.item_id" @click="fnSetPackageStatus(row.item_id,1)">关闭套餐</el-button>
            <el-button v-if="row.is_delete == 1" type="text" :loading="currentLoading == row.item_id" @click="fnSetPackageStatus(row.item_id,0)">开启套餐</el-button>
            <el-button type="text" :loading="currentLoading == row.item_id" @click="fnPopRefundInfo(row)">退款信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetShopItemList" />
    </div>

  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TiYouYouPackageList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        item_title: '',
        item_type: '',
        is_delete: '',
        subject_id: '',
        grade_id: '',
        total: 0
      },
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      packageStatus: commondata.OPEN_STATUS,
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      currentLoading: ''
    }
  },
  created() {
    this.fnGetShopItemList()
  },
  methods: {
    fnGetShopItemList: function() {
      this.bCreatePackage = false
      this.$http.getTyyShopItemList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnSetPackageStatus(id, is_delete) {
      this.currentLoading = id
      this.$http.tyyChangeRemoveItem({ id, is_delete }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.currentLoading = ''
        this.fnGetShopItemList()
      })
    },
    fnAddPakcage: function() {
      this.$router.push({
        path: 'tiyouyouAddPakcage'
      })
    },
    fnPopRefundInfo: function(info) {
      console.log(info)
      this.$alert(`是否可退: ${info.can_refund == '1' ? '可退' : '不可退'}</br>退款规则: 课时消耗${info.refund_days},可退${info.refund_price}元`, '退款信息', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        callback: action => {

        }
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
